export enum AttributeType {
  ACTUAL = 'ACTUAL',
  MAX_SET = 'MAX_SET',
  MIN_SET = 'MIN_SET',
  TARGET = 'TARGET'
}

export enum Mutability {
  READ_ONLY = 'READ_ONLY',
  READ_WRITE = 'READ_WRITE',
  WRITE_ONLY = 'WRITE_ONLY'
}

export interface VariableAttribute {
  type: AttributeType;
  value?: string;
  mutability: Mutability;
  persistent: boolean;
  constant: boolean;
}

export enum DataType {
  BOOLEAN = 'boolean',
  DATE_TIME = 'date-time',
  DECIMAL = 'decimal',
  INTEGER = 'int',
  MEMBER_LIST = 'csv-list',
  OPTION_LIST = 'csv-enum-list',
  SEQUENCE_LIST = 'csv-ordered-list',
  STRING = 'string'
}

export interface Variable {
  name: string;
  instance?: string;
  unit?: string;
  dataType: DataType;
  minLimit?: number;
  maxLimit?: number;
  enumValues?: string;
  supportsMonitoring: boolean;
  attributes: VariableAttribute[];
}

export type CreateVariable = Pick<Variable, 'name' | 'instance'>;

export interface Component {
  name: string;
  instance?: string;
  variables: Variable[];
}

export type ComponentGroupType = 'CHARGING_STATION' | 'EVSE' | 'CONNECTOR';

export interface ComponentGroup {
  type: ComponentGroupType;
  evseId?: number;
  connectorId?: number;
  componentGroups: ComponentGroup[];
  components: Component[];
}
